import { Button, Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { AddTubeChartLibraryListColumn, tempTubeChartLibraryData, TubeChartLibraryListColumn } from './utils/constants';
import { TubeChartLibraryListColumnType } from './utils/types';
import { formatTubeChartLibraryData } from './utils/helper';
import ComponentDeleteModal from '../../Common/DeleteModal/ComponentDeleteModal';
import {
  deleteTubeChartLibraryStart, getTubeChartImageStart, getTubeChartLibraryStart, importTubeChartStart,
} from './redux/tubeChartLibrarySlice';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';

function ScreenTubeChartLibrary() {
  const dispatch = useDispatch();
  //   const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTubeChartId, setSelectedTubeChartId] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRowIdWithColor, setSelectedRowIdWithColor] = useState('');

  const isAddTubeChartScreen = useMemo(() => location.pathname.includes('tube-chart-add'), [location?.pathname]);

  const {
    isLoading, stripChartData, totalStripChart, tubeChartImage,
  } = useSelector((state: RootState) => state.TubeChartLibraryReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getTubeChartLibraryStart(params));
    setSelectedRowIdWithColor('');
  };

  const handleTabCell = (id: string, event?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event) {
      const target = event.target as HTMLElement;

      if (target.closest('.delete-icon-class')) {
        return;
      }
    }

    if (!showDeleteModal) {
      const data = stripChartData?.find((item) => String(item?.Id) === id);
      dispatch(getTubeChartImageStart({ id: data?.TubeId || '' }));
      setSelectedRowIdWithColor(id);
      setSelectedId(id);
    }
  };

  const handleDelete = (id: string) => {
    const data = stripChartData?.find((item) => String(item?.Id) === id);
    setShowDeleteModal(true);
    setSelectedId(id);
    setSelectedTubeChartId(data?.TubeId || '');
  };

  const handelDeleteModal = () => {
    const paramData = {
      id: selectedTubeChartId,
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(deleteTubeChartLibraryStart(paramData));
    setShowDeleteModal(false);
    setSelectedRowIdWithColor('');
  };
  const handleImport = () => {
    dispatch(importTubeChartStart({ id: selectedId }));
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const showTubeChartImage = (newImage: string) => (
    <Grid container sx={{ marginTop: '0px', backgroundColor: '#FFFFFF' }}>
      <Grid item xs={12} sm={12} md={12}>
        <div style={{
          overflow: 'scroll',
          height: '60vh',
          width: '100%',
        }}
        >
          <img
            src={newImage}
            alt="Tube img"
            style={{
              width: 'auto',
              height: '120%',
              objectFit: 'contain',
            }}
          />
        </div>
      </Grid>
    </Grid>
  );

  return (
    <>
      <Grid container>
        {!isAddTubeChartScreen && (
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="Tube Chart Library" />
        </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <div className="div_job_container_info customBodyWithoutBtnContainer">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={selectedRowIdWithColor ? 6 : 12} className="dataTableCustomMargin customDataTableStyles">
                <DataTable<TubeChartLibraryListColumnType>
                  data={tempTubeChartLibraryData?.Data?.length > 0 ? formatTubeChartLibraryData(stripChartData) : []}
                  totalRecords={totalStripChart}
                  columns={isAddTubeChartScreen ? AddTubeChartLibraryListColumn : TubeChartLibraryListColumn}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleData={handleData}
                  handleDelete={handleDelete}
                  handleTabCell={handleTabCell}
                  selectedRowIdWithColor={selectedRowIdWithColor}
                />
              </Grid>
              {selectedRowIdWithColor && (
              <Grid item xs={12} sm={12} md={6}>
                {showTubeChartImage(tubeChartImage)}
                {isAddTubeChartScreen
                && (
                <Button
                  className="button_save_and_next"
                  style={{
                    display: 'flex', justifySelf: 'end', position: 'absolute', bottom: '40px',
                  }}
                  onClick={handleImport}
                >
                  Import
                </Button>
                )}
              </Grid>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setShowDeleteModal(false)}
        handleDelete={handelDeleteModal}
      />
    </>
  );
}

export default ScreenTubeChartLibrary;
